import React from "react";
import { UserRoleSettings } from "us.common/components";

export default () => {
  return <UserRoleSettings.Home />;
};
